(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name wbTimedInformationDialog.constant:wbTimedInformationDialog
   *
   * @description
   *
   */
  angular
    .module('wbTimedInformationDialog')
    .constant('wbTimedInformationDialogConstant', {
      edenredServiceAlert: {
        name: 'edenredServiceAlertDialog',
        startDate: '2025-06-30 11:30',
        endDate: '2025-09-01 11:30',
        title: '',
        description: '<img class="img-responsive" src="images/discount.jpg" />',
        onceOnly: false
      }
    }
    );
}());
